module.exports = __webpack_public_path__ + "media/door_close.57e154bf.mp3";